/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Templates_TitleInputs */

const en_us2_coaching_templates_title = /** @type {(inputs: Coaching_Templates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan templates`)
};

const pt_br2_coaching_templates_title = /** @type {(inputs: Coaching_Templates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos de plano`)
};

const pt_pt2_coaching_templates_title = /** @type {(inputs: Coaching_Templates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos de plano`)
};

/** @type {(inputs: Coaching_Templates_TitleInputs) => LocalizedString} */
const es_419_coaching_templates_title = en_us2_coaching_templates_title;

/** @type {(inputs: Coaching_Templates_TitleInputs) => LocalizedString} */
const fr_fr2_coaching_templates_title = en_us2_coaching_templates_title;

/** @type {(inputs: Coaching_Templates_TitleInputs) => LocalizedString} */
const de_de2_coaching_templates_title = en_us2_coaching_templates_title;

/** @type {(inputs: Coaching_Templates_TitleInputs) => LocalizedString} */
const it_it2_coaching_templates_title = en_us2_coaching_templates_title;

/**
* | output |
* | --- |
* | "Plan templates" |
*
* @param {Coaching_Templates_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_templates_title = /** @type {((inputs?: Coaching_Templates_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Templates_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_templates_title(inputs)
	if (locale === "es-419") return es_419_coaching_templates_title(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_templates_title(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_templates_title(inputs)
	if (locale === "de-DE") return de_de2_coaching_templates_title(inputs)
	if (locale === "it-IT") return it_it2_coaching_templates_title(inputs)
	return en_us2_coaching_templates_title(inputs)
});
export { coaching_templates_title as "coaching.templates_title" }